import { GetColorName } from 'hex-color-to-color-name';
import { converters } from '@yola/yola-palette-generator';

const { hsl2hex } = converters;

const getCustomSchemeLabel = (hslColor) => {
  const hexColor = hsl2hex(hslColor);
  return GetColorName(hexColor) || hexColor;
};

export default getCustomSchemeLabel;
